export var ListType;
(function (ListType) {
    ListType["DEFAULT"] = "DEFAULT";
    ListType["HOME"] = "HOME";
    ListType["BAD"] = "BAD";
})(ListType || (ListType = {}));
